import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; 
import './RegisterDespesaPopup.css';
import { API_BASE_URL } from "../../../../config";
import { FaSave, FaTimes } from 'react-icons/fa';

const initialState = {
    data: '',
    descricao: '',
    numero_nota_fiscal: '',
    fornecedor: '',
    produto: '',
    unidade: '',
    quantidade: '',
    valor_unitario: '',
    total: '',
    tipo_de_despesa: '',
    validade: '',
    empresa_logo: '',
};

const tiposDespesa = [
    "Compra de florestas", "Compra de mudas", "Compra de sementes","Serviço de Conserto de Cerca" ,
    "Serviço de abertura e manutenção de estradas", "Serviços de corte", "Serviços de plantio",
    "Serviços de coroamento", "Serviços de roçada", "Serviços de desrama", "Serviço de preparo de solo",
    "Aplicação de adubo", "Aplicação de herbicidas", "Aplicação de inseticidas", "Serviço de georreferenciamento",
    "Serviço de Construção de Cerca", "Serviço de Desbaste", "Serviço de Contagem de Árvores", "Serviço de Inventário",
    "Serviço de Corte de Brotos", "Serviço de Limpeza de Área", "Serviço de Replante"
];

const RegisterDespesaPopup = ({ isOpen, onClose, imovelId, onSave }) => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState(initialState);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });

    useEffect(() => {
        if (isOpen) {
            setFormData(initialState);
            setMessage({ type: '', text: '' });
            setIsLoading(false);
        }
    }, [isOpen]);

    useEffect(() => {
        const qtd = parseFloat(formData.quantidade) || 0;
        const valor = parseFloat(formData.valor_unitario) || 0;
        setFormData(prev => ({ ...prev, total: (qtd * valor).toFixed(2) }));
    }, [formData.quantidade, formData.valor_unitario]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (isLoading) return; 

        const token = localStorage.getItem('token');
        if (!token) {
            setMessage({ type: 'error', text: 'Sessão expirada. Faça login novamente.' });
            setTimeout(() => navigate('/'), 2000);
            return;
        }

        setIsLoading(true);
        setMessage({ type: '', text: '' });

        try {
            const response = await fetch(`${API_BASE_URL}/api/imoveis/${imovelId}/despesas`, {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                setMessage({ type: 'success', text: 'Despesa salva com sucesso!' });
                
                if (typeof onSave === 'function') {
                    onSave();
                }

                setTimeout(() => {
                    onClose();
                }, 1500);
            } else {
                const errorData = await response.json();
                setMessage({ type: 'error', text: errorData.error || 'Erro ao salvar despesa.' });
                setIsLoading(false); 
            }
        } catch (error) {
            setMessage({ type: 'error', text: 'Erro de conexão com o servidor.' });
            setIsLoading(false); 
        }
    };

    if (!isOpen) return null;

    return (
        <div className="register-despesa-overlay">
            <div className="register-despesa-content">
                <header className="register-despesa-header">
                    <h2>Cadastrar Nova Despesa</h2>
                    <button className="close-btn" onClick={onClose} disabled={isLoading}><FaTimes /></button>
                </header>

                <form onSubmit={handleSubmit}>
                    <main className="register-despesa-body">
                        {message.text && (
                            <div className={`message-banner ${message.type}-message`}>
                                {message.text}
                            </div>
                        )}

                        <div className="form-grid">
                            <div className="form-group">
                                <label>Data</label>
                                <input name="data" type="date" value={formData.data} onChange={handleChange} className="form-input" required disabled={isLoading} />
                            </div>
                            <div className="form-group">
                                <label>Descrição</label>
                                <input name="descricao" type="text" value={formData.descricao} onChange={handleChange} className="form-input" required disabled={isLoading} />
                            </div>
                            <div className="form-group">
                                <label>Nº Nota Fiscal</label>
                                <input name="numero_nota_fiscal" type="text" value={formData.numero_nota_fiscal} onChange={handleChange} className="form-input" required disabled={isLoading} />
                            </div>
                            <div className="form-group">
                                <label>Fornecedor</label>
                                <input name="fornecedor" type="text" value={formData.fornecedor} onChange={handleChange} className="form-input" required disabled={isLoading} />
                            </div>
                            <div className="form-group">
                                <label>Produto</label>
                                <input name="produto" type="text" value={formData.produto} onChange={handleChange} className="form-input" required disabled={isLoading} />
                            </div>
                            <div className="form-group">
                                <label>Unidade</label>
                                <input name="unidade" type="text" value={formData.unidade} onChange={handleChange} className="form-input" required disabled={isLoading} />
                            </div>
                            <div className="form-group">
                                <label>Quantidade</label>
                                <input name="quantidade" type="number" step="0.01" value={formData.quantidade} onChange={handleChange} className="form-input" required disabled={isLoading} />
                            </div>
                            <div className="form-group">
                                <label>Valor Unitário</label>
                                <input name="valor_unitario" type="number" step="0.01" value={formData.valor_unitario} onChange={handleChange} className="form-input" required disabled={isLoading} />
                            </div>
                            <div className="form-group">
                                <label>Vencimento</label>
                                <input name="validade" type="date" value={formData.validade} onChange={handleChange} className="form-input" required disabled={isLoading} />
                            </div>
                            <div className="form-group">
                                <label>Tipo de Despesa</label>
                                <select name="tipo_de_despesa" value={formData.tipo_de_despesa} onChange={handleChange} className="form-input" required disabled={isLoading}>
                                    <option value="">Selecione...</option>
                                    {tiposDespesa.map(tipo => (
                                        <option key={tipo} value={tipo}>{tipo}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Empresa</label>
                                <select name="empresa_logo" value={formData.empresa_logo} onChange={handleChange} className="form-input" disabled={isLoading}>
                                    <option value="">Selecione a Empresa (Opcional)</option>
                                    <option value="Rio Verde">Rio Verde</option>
                                    <option value="4s Reflorestamento">4s reflorestamento</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Total</label>
                                <input name="total" type="text" value={formData.total} readOnly className="form-input" style={{ backgroundColor: '#e9ecef', fontWeight: 'bold' }} />
                            </div>
                        </div>
                    </main>

                    <footer className="register-despesa-footer">
                        <button type="button" className="modal-btn btn-cancel" onClick={onClose} disabled={isLoading}>
                            <FaTimes /> Cancelar
                        </button>
                        <button type="submit" className="modal-btn btn-success" disabled={isLoading}>
                            <FaSave /> {isLoading ? 'Salvando...' : 'Salvar Despesa'}
                        </button>
                    </footer>
                </form>
            </div>
        </div>
    );
};

export default RegisterDespesaPopup;
